import { FormField, Popover, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import { mdiAlert, mdiCheckDecagram, mdiEmailFastOutline, mdiInfinity } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;



//const storeAdmin = useStoreAdmin();
export const AdminRACRates = () => {
    const { menu } = useGlobalState();
    const [sideOpen, setSideOpen] = useState(false);
    const [rates, setRates] = useState<any[]>([]);
    const { parameters, data } = useGlobalState();
    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/rac/invoices/rates',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    orderBy: "hangar",
                    order: "asc",
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.rates) {
                setRates(data.rates)
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleRefresh()
    }, []);

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const filtered: any[] = rates.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [
            item.RUT,
            item.hangar,
            item?.jsonSII?.razonSocial,
            ...(item.jsonEmails || []) // Safely spread emails into the array
        ].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}>
                            Tarifas RAC</Header>


                        <Table
                            variant='embedded'
                            items={paginated}
                            filter={
                                <TextFilter
                                    filteringText={filterValue}
                                    filteringPlaceholder="Buscar..."
                                    onChange={({ detail }) => setFilterValue(detail.filteringText)}
                                />
                            }


                            pagination={
                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {rates.length > 0 && (
                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>
                            }

                            columnDefinitions={[
                                {
                                    id: "RUT", header: "RUT", cell: item => (
                                        <FormField label={item?.RUT}>
                                            {item?.jsonSII?.razonSocial}</FormField>)
                                },
                                { id: "Hangar", header: "Hangar", cell: item => item?.hangar },
                                {
                                    id: "installments",
                                    header: "Cuotas",
                                    cell: item => (
                                        <>
                                            {item?.installmentsExecuted}{" / "}
                                            {item?.installmentsTotal === 0 ? (
                                                <Icon path={mdiInfinity} size={0.8} />
                                            ) : (
                                                item?.installmentsTotal
                                            )}
                                            {item?.installmentsTotal > 0 && item?.installmentsTotal === item?.installmentsExecuted &&
                                                (<>
                                                    <Popover dismissButton={false} header='Completado' content='Se han ejecutado todas las cuotas de este plan de pagos.' triggerType="custom">
                                                        <Icon path={mdiAlert} size={0.7} color={"orange"} />
                                                    </Popover>
                                                </>)
                                            }
                                        </>
                                    ),
                                },
                                { id: "Canon", header: "Canon", cell: item => `${item?.amount} ${item?.currency}` },
                                {
                                    id: "emails", header: "", cell: item =>
                                        Array.isArray(item?.jsonEmails) && item.jsonEmails.length > 0 &&
                                        (

                                            <Popover dismissButton={false}
                                                triggerType="custom"
                                                header="Emails"
                                                content={
                                                    <div>
                                                        {item.jsonEmails.map((email: string, index: number) => (
                                                            <div key={index}>{email}</div>
                                                        ))}
                                                    </div>
                                                }
                                            >
                                                <Icon path={mdiEmailFastOutline} size={1} />
                                            </Popover>
                                        )

                                },
                                {
                                    id: "isPaid",
                                    header: "Anticipo",
                                    cell: (item) =>
                                        item?.isPaid === 1 ? (
                                            <Icon path={mdiCheckDecagram} size={1} color="green" />
                                        ) : "",
                                },
                            ]}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin tarifas según criterios</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />

                    </SpaceBetween>

                </>
            }
        />);
};